export enum ICON_TYPE {
  DELETE = 'DELETE',
  BLACK_ICON_DELETE = 'BLACK_ICON_DELETE',
  PENCIL = 'PENCIL',
}
